export default __webpack_public_path__ + "static/media/car1.803f49c3.png";